import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InstaLogo from '../../../../../assets/insta_logo.png';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../helpers/AxiosAPI';
import {
  dAPI_Delete_Ingetration,
  dAPI_Delete_Ingetration_Group,
  putAPI_Update_OnOff,
} from '../../../../../constants/APIs';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import Switch from 'rc-switch';
import InstagramIntegrationList from './InstagramIntegrationList';

export default function InstagramIntegrationThumb({
  integration,
  allProperties,
  LoadIntegrations,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    !integration.disabled
  );
  useEffect(() => {
    const result = integration.properties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    if (result.length > 2) {
      const filterResults = result.slice(0, 2);
      setFormatedProperties(filterResults.map((elem) => elem.name).join(', '));
      setMoreProperties(
        'and ' + (result.length - filterResults.length) + ' more'
      );
    } else {
      const filterResults = result.filter((elem) => elem !== undefined);
      setFormatedProperties(filterResults.map((elem) => elem.name).join(', '));
    }
  }, [integration, allProperties]);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id
        }/?group_id=${getGroupID()}`,
    }).then((res) => {
      let updateRequest = {
        updater: 'dashboard',
      };
      AxiosAPI({
        method: 'delete',
        url: `${dAPI_Delete_Ingetration_Group}/${integration.channelDetails.pageId}`,
        data: updateRequest,
      })
        .then((result) => {
          const fburl = `${process.env.REACT_APP_FB_GRAPH_API}oauth/access_token?client_id=${process.env.REACT_APP_FB_APP_ID}&client_secret=${process.env.REACT_APP_FB_APP_SCRET}&grant_type=client_credentials`;
          AxiosPublicAPI({
            method: 'post',
            url: fburl,
          }).then((fbData) => {
            const fbdeleteurl = `${process.env.REACT_APP_FB_GRAPH_API}${integration.channelDetails.pageId}/subscribed_apps?access_token=${fbData.data.access_token}`;
            AxiosPublicAPI({
              method: 'delete',
              url: fbdeleteurl,
            }).then((fbDeleteData) => {
              console.log(fbDeleteData.data);
            });
          });

          toggle();
          LoadIntegrations();
        })
        .catch((err) => {
          console.log('err', err);
        });
    });
  };

  const handleOnOff = (onoff) => {
    // if (onoff) {
    //   AxiosPublicAPI({
    //     method: 'get',
    //     url: `${process.env.REACT_APP_CHAT_API}/disabledfb/${integration.channelDetails.pageId}`,
    //   }).then((res) => {
    //     console.log('on/off');
    //   });
    // } else {
    //   AxiosPublicAPI({
    //     method: 'get',
    //     url: `${process.env.REACT_APP_CHAT_API}/enabledfb/${integration.channelDetails.pageId}`,
    //   }).then((res) => {
    //     console.log('on/off');
    //   });
    // }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff },
    }).then((res) => {
      console.log('on/off');
    });
  };

  const handleSwitchChange = (value) => {
    console.log(value);
    setCheckedPrimarySmall(value);
    handleOnOff(!value);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This action will permanently remove the integration. Are you sure you want to delete the integration?
                </ModalHeader>
                <ModalBody className="d-flex justify-content-space-between">
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Confirm
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      {integration ? (
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card className="d-flex flex-row" style={{ height: '215px' }}>
            <h3 className="integrationChannel">
              <img
                src={InstaLogo}
                alt="Logo"
                style={{ maxWidth: '30px' }}
              />
            </h3>
            <Switch
              className="agentswitch custom-switch-primary custom-switch-small integrationremove"
              checked={checkedPrimarySmall}
              onChange={(primary) => handleSwitchChange(primary)}
            />

            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-3">
                  <NavLink
                    to={{
                      pathname: '/app/pages/instagramdetail/' + integration.id,
                    }}
                    key={integration.id}
                  >
                    <div className="text-center">
                      {/* <CardImg
                        top
                        src={`https://graph.facebook.com/${integration.channelDetails.facebookId}/picture?type=normal`}
                        alt="Card image cap"
                        className="img-thumbnail border-0 rounded-circle list-thumbnail"
                      /> */}
                      <div className="mb-1">
                        {integration.channelDetails.userName}
                      </div>
                      <div className="mb-2">
                        <b>{formatedProperties} </b>
                        <b>{moreProperties}</b>
                      </div>
                    </div>
                  </NavLink>
                </Colxx>
              </Row>
            </CardBody>
            <div className='integrationdelete'>
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ color: 'var(--theme-color-1)' }}
                cursor="pointer"
                onClick={toggle}
              />
            </div>
          </Card>
        </Colxx>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
